import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EmailBuilderModule } from '@galaxy/email-ui/email-builder';
import { DynamicComponentSelectorModule } from '@galaxy/email-ui/email-builder/src/components/dynamic-component-selector';
// import { ContentEditorModule } from '../../../../../../marketing/base-template-editing/content-editor/content-editor.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { GalaxyInputModule } from '@vendasta/galaxy/input';
import { GalaxyPageModule } from '@vendasta/galaxy/page';
import { GalaxyPopoverModule } from '@vendasta/galaxy/popover';
import { GalaxyStatisticModule } from '@vendasta/galaxy/statistic';
import { AsyncUiModule } from '@vendasta/uikit';
// import { BaseTemplateEditingModule } from '../../../../../../marketing/base-template-editing/base-template-editing.module';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyLoadingSpinnerModule } from '@vendasta/galaxy/loading-spinner';
import { GalaxyPipesModule } from '@vendasta/galaxy/pipes';
// import { PreviewBusinessSelectorModule } from '../../../../../../shared/preview-business-selector/preview-business-selector.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { EmailStatsModule } from '@galaxy/email-ui/email-activity';
import { PreviewImageContainerComponent } from '../../../common/preview-image-container/preview-image-container.component';

@NgModule({
  imports: [
    CommonModule,
    EmailBuilderModule,
    GalaxyInputModule,
    GalaxyPopoverModule,
    GalaxyAlertModule,
    GalaxyPipesModule,
    GalaxyPageModule,
    GalaxyStatisticModule,
    FormsModule,
    GalaxyFormFieldModule,
    MatDividerModule,
    DynamicComponentSelectorModule,
    // ContentEditorModule,
    AsyncUiModule,
    MatMenuModule,
    // BaseTemplateEditingModule,
    GalaxyLoadingSpinnerModule,
    MatButtonModule,
    MatIconModule,
    TranslateModule,
    // PreviewBusinessSelectorModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    EmailStatsModule,
    PreviewImageContainerComponent,
  ],
})
export class EmailEditorModule {}
